import Public from "./PublicAPI";
import PrivateAPI from "./PrivateAPI";

export const PublicAPI = Public;
const Commander = { ...PublicAPI, ...PrivateAPI };

export default Commander;
